import React from "react";
import { Link as GatsbyLink } from "gatsby";
import { Box, Link } from "theme-ui";
import { Text, Heading } from "theme-ui";
import Img from "gatsby-image";

const ArticleItem = ({ title, image, slug, publishedAt, body }) => (
  <Link to={slug} as={GatsbyLink} sx={{ mb: [4, 5], display: "block" }}>
    <Box sx={{ mb: [2, 3] }}>
      <Img fluid={image.fluid} />
    </Box>
    <Text as="p" variant="caption" sx={{ mb: 2, textTransform: "capitalize" }}>
      {publishedAt}
    </Text>
    <Heading as="h2" variant="lead">
      {title}
    </Heading>
  </Link>
);

export default ArticleItem;
